const { useEffect, useState } = wp.element;

import { hi } from 'date-fns/locale';
import DatePicker from 'react-datepicker'
import SyncLoader from 'react-spinners/SyncLoader'

const Component = ({ 
    date, 
    setDate, 
    timeslot, 
    setTimeslot, 
    loadingAvailableTimeslots, 
    availableTimeslots, 
    handleGetAvailableDates,
    availableDates,
}) => {
    return (
        <div id="section-date-time" className={`section ${true ? 'reverse-datepicker-timepicker-colors' : ''}`}>
            <div className="container grid">
                <h2 className="section-title">Velg tidspunkt</h2>
                <p className="section-description">Velg dag og et tidspunkt som passer deg.</p>

                <div className="datepicker-timepicker-wrapper">
                    <div className="datepicker">
                        <h3>Velg dato</h3>
                        <DatePicker 
                            locale="nb"
                            formatWeekDay={(nameOfDay) => nameOfDay.substr(0, 1)}
                            selected={date}
                            onChange={(date) => setDate(date)}
                            minDate={new Date()}
                            highlightDates={availableDates.map((date) => {
                                return new Date(date.DateFree);
                            })}
                            inline
                        />
                    </div>

                    <div className="timepicker" id="section-time">
                        <h3>Velg tid</h3>
                        {
                            loadingAvailableTimeslots &&
                            <div className="loading" style={{ marginTop: 40 }}>
                                <SyncLoader color={'#aaa'} loading={true} size={7} />
                            </div>
                        }

                        {
                            !loadingAvailableTimeslots &&
                            availableTimeslots &&
                            <>
                                <div className="timeslots">
                                    {
                                        availableTimeslots.map((item, index) => {
                                            return (
                                                <button className={`timeslot ${timeslot?.startLocal === item.startLocal ? 'active' : ''}`} onClick={() => { setTimeslot(item) }} key={index}>
                                                    {new Date(item.startLocal).toLocaleTimeString('no-NO', { hour: '2-digit', minute: '2-digit' })}
                                                </button>
                                            )
                                        })
                                    }
                                </div>
                            </>
                        }
                        
                        {
                            date &&
                            !loadingAvailableTimeslots &&
                            availableTimeslots.length === 0 &&
                            <>
                                Fant ingen ledige timer.
                            </>
                        }
                        
                        {
                            !date &&
                            !loadingAvailableTimeslots &&
                            availableTimeslots.length === 0 &&
                            <>
                                Velg en dato for å se ledige timer.
                            </>
                        }
                    </div>
                </div>
            </div>

            {
                date &&
                timeslot &&
                <svg className="progress-arrow" width="64" height="32" viewBox="0 0 64 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0H64L32 32L0 0Z" fill="currentColor"/>
                </svg>
            }
        </div>
    )
}

export default Component;